module.exports = __webpack_public_path__ + "img/nouveau.b208c39d.png";